const Ext = require('ext')
const PriceField = require('admin/component/form/PriceField')

const ReadOnlyPriceField = Ext.define(null, {
  extend: PriceField,

  constructor(cfg = {}) {
    cfg.readOnly = true
    if (!cfg.cls) {
      cfg.cls = 'readonly-textfield'
    }

    if (cfg.clone) {
      Ext.applyIf(cfg, {
        helpText: cfg.clone.helpText,
        hideLabel: cfg.clone.hideLabel,
        fieldLabel: cfg.clone.fieldLabel,
        name: cfg.clone.name,
        width: cfg.clone.width
      })
    }

    this.callParent([cfg])
  },

  setValue(value) {
    if (value != null) {
      this.callParent([value])
    }
  },

  highlighted: false,

  highlight() {
    return (this.highlighted = true)
  },

  unHighlight() {
    return (this.highlighted = false)
  },

  isHighlighted() {
    return this.highlighted
  }
})

module.exports = ReadOnlyPriceField
